import React from 'react';
import { cn } from '~/helpers/utils';

type CompanyListItemTagProps = {
  className?: string;
  children: React.ReactNode;
};

const CompanyListItemTag: React.FC<CompanyListItemTagProps> = ({ className, children }) => {
  return (
    <span className={cn(
      'flex items-center gap-2 bg-sand-50 text-xs leading-none font-semibold text-black rounded-full py-2 px-3',
      className,
    )}>
      {children}
    </span>
  );
};

export default CompanyListItemTag;